import { AdminActionsType, AdminState, Impersonation, ImportCsvResult } from './admin.types';
import { INITIAL_ACCOUNT_STATE } from '../account/Constants';

export const GET_BUSINESS_LIST: AdminActionsType = 'GET_BUSINESS_LIST';

export const IMPERSONATE: AdminActionsType = 'IMPERSONATE';
export const CLEAR_IMPERSONATION: AdminActionsType = 'CLEAR_IMPERSONATION';
export const GET_LOCKED_ACCOUNTS: AdminActionsType = 'GET_LOCKED_ACCOUNTS';
export const EMAIL_BLAST: AdminActionsType = 'EMAIL_BLAST';
export const IMPORT_CSV: AdminActionsType = 'IMPORT_CSV';

export const initialImpersonationState: Impersonation = {
  authToken: '',
  account: INITIAL_ACCOUNT_STATE
};

export const initialImportCsvResult: ImportCsvResult = {
  registered: 0,
  failedProspects: []
};

export const initialAdminState: AdminState = {
  statusCode: 0,
  businessList: [],
  impersonation: initialImpersonationState,
  lockedAccounts: [],
  sentEmails: 0,
  importCsvResult: initialImportCsvResult
};


// WEBPACK FOOTER //
// ./src/admin/admin.constants.tsx